import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@app/providers/useAuth";
import { ROUTES } from "@shared/constants";
import type { ReactNode } from "react";

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Route guard that redirects unauthenticated users to the home page.
 * Wraps protected route elements in the AppRouter.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // While checking auth, render nothing to avoid flash
    return null;
  }

  if (!isAuthenticated) {
    // Redirect to home, saving the intended destination
    return <Navigate to={ROUTES.HOME} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
